import TransactionsByDate from "components/shared/TransactionsByDate";
import { getCardTransactions } from "store/api/apiSlice";

const Transactions = () => {
  const { data: cardTransactions = [] } = getCardTransactions({
    pollingInterval: 2_000,
  });
  return <TransactionsByDate transactions={cardTransactions} />;
};

export default Transactions;
